import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import * as rsuite from "rsuite";
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import axios from 'axios';
import * as HiIcon from 'react-icons/hi';
import TaskDetail from './TaskDetail';

// گفتگوی یک وظیفه.
//
// دو نما در یک کشو: فهرست گفتگوهای همان وظیفه، و با انتخاب یکی، رشته
// پیام ها. برگشت به فهرست هم هست.
//
// پیوست ها دقیقا مثل تیکت آپلود می شوند: multipart با نام های Attachments[i]
// و نمایش از مسیر /taskfiles.
// این سه تا عمدا بیرون از کامپوننت اصلی تعریف شده اند.
//
// اگر داخل بدنه تعریف شوند، با هر رندر یک تابع تازه ساخته می شود و React
// آن را نوعِ کامپوننتِ دیگری می بیند: زیردرخت را unmount و دوباره mount
// می کند. نتیجه اش این بود که با هر حرفی که تایپ می شد، فوکوس از داخل
// جعبه متن بیرون می پرید.

const AttachmentLinks = ({ items }) => (
    items && items.length > 0 ?
        <div className='mt-1'>
            {
                items.map(file => (
                    <rsuite.Button
                        key={file.id}
                        appearance="subtle"
                        size="xs"
                        className='ms-1'
                        target='_blank'
                        href={General.TaskFileRoute() + file.id + file.extension}
                    >
                        <HiIcon.HiOutlinePaperClip /> پیوست
                    </rsuite.Button>
                ))
            }
        </div>
        :
        null
);

const MessageBox = ({ item, currentUserId }) => {
    const mine = (item.senderId || "").toLowerCase() === currentUserId;
    return (
        <div style={{
            background: mine ? '#eef4fd' : '#f4f6f8',
            borderRadius: 8,
            padding: 10,
            marginBottom: 8
        }}>
            <div style={{ fontSize: 11, color: '#8c97a3', marginBottom: 4 }}>
                {item.senderFullName} — {item.createDate} {item.createTime}
            </div>
            <div style={{ fontSize: 13, whiteSpace: 'pre-wrap', lineHeight: '26px' }}>
                {item.msg}
            </div>
            <AttachmentLinks items={item.attachments} />
        </div>
    );
};

const Composer = ({ message, onMessageChange, files, onPick, onRemoveFile,
    fileInputRef, loading, onSend, sendLabel }) => (
    <>
        <rsuite.Input
            as="textarea"
            rows={3}
            value={message}
            onChange={onMessageChange}
            placeholder="متن پیام"
            className='mt-2'
        />
        <div className='mt-2'>
            <input
                type="file"
                multiple
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={onPick}
            />
            <rsuite.Button size="sm" appearance="ghost"
                onClick={() => fileInputRef.current.click()}>
                <HiIcon.HiOutlinePaperClip /> افزودن پیوست
            </rsuite.Button>
            {
                files.map((file, index) => (
                    <rsuite.Tag key={index} closable className='ms-1'
                        onClose={() => onRemoveFile(index)}>
                        {file.name}
                    </rsuite.Tag>
                ))
            }
        </div>
        <div align="left" className='mt-2'>
            {
                !loading ?
                    <rsuite.Button appearance="primary" onClick={onSend}>{sendLabel}</rsuite.Button>
                    :
                    <rsuite.Button appearance="primary" disabled><rsuite.Loader /></rsuite.Button>
            }
        </div>
    </>
);

const TaskConversation = forwardRef((props, ref) => {

    //#region const

    const FileInputRef = useRef();
    const TaskDetailRef = useRef();

    const [TaskId, setTaskId] = useState(General.GuidEmpty());
    const [TaskTitle, setTaskTitle] = useState("");
    const [List, setList] = useState([]);
    const [Current, setCurrent] = useState(null);
    const [ShowLoader, setShowLoader] = useState(false);

    //--> جزئیات وظیفه، همینجا و بسته. گفتگو معمولا وسط کار خوانده می شود و
    //--> «این بحث سر کدام وظیفه بود» سوال بعدی است؛ ولی همیشه نیست، پس باز
    //--> بودنش رشته پیام ها را عقب می راند. عمدا هم کشوی تازه ای باز نمی کند:
    //--> خود گفتگو داخل یک کشو است و کشو روی کشو روی موبایل بی استفاده می شود.
    const [ShowTask, setShowTask] = useState(false);

    //--> فرم گفتگوی جدید
    const [ShowNew, setShowNew] = useState(false);
    const [Subject, setSubject] = useState("");

    const [Message, setMessage] = useState("");
    const [Files, setFiles] = useState([]);

    const CurrentUserId = (localStorage.getItem("UserId") || "").toLowerCase();
    //#endregion

    //#region Methods

    useImperativeHandle(ref, () => ({
        Show(WorkTaskId, Title) {
            setTaskId(WorkTaskId);
            setTaskTitle(Title ? Title : "");
            setCurrent(null);
            setShowNew(false);
            setShowTask(false);
            setSubject("");
            setMessage("");
            setFiles([]);
            BindList(WorkTaskId);
        }
    }))

    //--> TaskDetail خودش با Show پر می شود و تا باز نشود اصلا در درخت نیست،
    //--> پس فراخوانی بعد از همان رندری است که پنل را سوار می کند
    useEffect(() => {
        if (ShowTask && TaskDetailRef.current) {
            TaskDetailRef.current.Show(TaskId);
        }
    }, [ShowTask, TaskId])

    const BindList = (workTaskId) => {
        setShowLoader(true);
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/TaskConversation/GetByTaskId",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                WorkTaskId: workTaskId
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setList(res.data);
                setShowLoader(false);
            })
            .catch(error => {
                setShowLoader(false);
                ShowError(error);
            })
    }

    const OpenConversation = (Id) => {
        setShowLoader(true);
        setMessage("");
        setFiles([]);
        setShowTask(false);
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/TaskConversation/GetById",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                Id: Id
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setCurrent(res.data);
                setShowLoader(false);
            })
            .catch(error => {
                setShowLoader(false);
                ShowError(error);
            })
    }

    const ShowError = (error) => {
        if (error.response && error.response.status === 403) {
            General.ShowMsg(Enum.MsgType.error, General.AccessDenied());
        }
        else if (error.response && error.response.status === 401) {
            General.ShowMsg(Enum.MsgType.error, General.unAuthorize());
        }
        else {
            General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
        }
    }

    const AddFiles = (e) => {
        const picked = Array.from(e.target.files ? e.target.files : []);
        setFiles(Files.concat(picked));
        //--> ورودی خالی می شود تا انتخاب دوباره همان فایل هم رویداد بدهد
        e.target.value = null;
    }

    const RemoveFile = (index) => {
        setFiles(Files.filter((item, i) => i !== index));
    }

    //--> ساخت گفتگو و پاسخ دادن یک شکل داده می فرستند، فقط آدرسشان فرق دارد
    const BuildFormData = () => {
        let data = new FormData();
        data.append("Message", Message);
        for (let i = 0; i < Files.length; i++) {
            data.append("Attachments[" + i + "].Id", General.GuidEmpty());
            data.append("Attachments[" + i + "].File", Files[i]);
        }
        return data;
    }

    const Send = (url, extra) => {
        if (!Message || Message.trim() === "") {
            General.ShowMsg(Enum.MsgType.error, "متن پیام را وارد نمایید");
            return;
        }
        setShowLoader(true);
        let data = BuildFormData();
        Object.keys(extra).forEach(key => data.append(key, extra[key]));

        axios({
            method: "Post",
            url: General.ApiRoute() + url,
            headers: { ApiKey: process.env.REACT_APP_APIKEY },
            data: data,
            withCredentials: true
        })
            .then(function (res) {
                setShowLoader(false);
                if (!res.data.isSuccess) {
                    General.ShowMsg(Enum.MsgType.error, res.data.error);
                    return;
                }
                General.ShowMsg(Enum.MsgType.success, General.SaveSuccess());
                setMessage("");
                setFiles([]);
                setSubject("");
                setShowNew(false);
                if (Current) {
                    OpenConversation(Current.id);
                }
                BindList(TaskId);
                if (props.onChange) {
                    props.onChange();
                }
                //--> پیام که رفت، کار کاربر با این کشو تمام است. باز ماندنش
                //--> یعنی خودش باید ببندد تا فهرست تازه شده پشت سرش را ببیند.
                if (props.onSent) {
                    props.onSent();
                }
            })
            .catch(error => {
                setShowLoader(false);
                ShowError(error);
            })
    }

    const SendNew = () => {
        if (!Subject || Subject.trim() === "") {
            General.ShowMsg(Enum.MsgType.error, "موضوع گفتگو را وارد نمایید");
            return;
        }
        Send("/TaskConversation/Insert", { "WorkTaskId": TaskId, "Subject": Subject });
    }

    const SendReply = () => {
        Send("/TaskConversation/Reply", { "Id": Current.id });
    }

    const SetClosed = (Id, close) => {
        setShowLoader(true);
        axios({
            method: "Post",
            url: General.ApiRoute() + "/TaskConversation/" + (close ? "Close" : "Reopen"),
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                id: Id
            },
            withCredentials: true
        })
            .then(function (res) {
                setShowLoader(false);
                if (!res.data.isSuccess) {
                    General.ShowMsg(Enum.MsgType.error, res.data.error);
                    return;
                }
                if (Current) {
                    OpenConversation(Id);
                }
                BindList(TaskId);
                if (props.onChange) {
                    props.onChange();
                }
            })
            .catch(error => {
                setShowLoader(false);
                ShowError(error);
            })
    }
    //#endregion


    //--> نمای رشته پیام ها
    if (Current) {
        return (
            <div>
                <rsuite.Button size="sm" appearance="subtle" onClick={() => setCurrent(null)}>
                    ‹ بازگشت به فهرست گفتگوها
                </rsuite.Button>

                <div style={{ fontSize: 15, fontWeight: 600, marginTop: 10 }}>{Current.subject}</div>
                <div style={{ fontSize: 11, color: '#8c97a3', marginBottom: 12 }}>
                    <span className='HandCursor' style={{ color: '#2a78d6' }}
                        onClick={() => setShowTask(!ShowTask)}>
                        وظیفه: {Current.taskTitle}
                        {
                            ShowTask ?
                                <HiIcon.HiOutlineChevronUp style={{ marginRight: 3 }} />
                                :
                                <HiIcon.HiOutlineChevronDown style={{ marginRight: 3 }} />
                        }
                    </span>
                    {Current.isClosed ? ' — بسته شده در ' + Current.closedDate : ''}
                </div>

                {
                    ShowTask ?
                        <div style={{
                            border: '1px solid #e6e9ed',
                            borderRadius: 8,
                            padding: '4px 12px 12px 12px',
                            marginBottom: 12
                        }}>
                            <TaskDetail ref={TaskDetailRef} />
                        </div>
                        :
                        null
                }

                {
                    Current.messages && Current.messages.map(item => (
                        <MessageBox key={item.id} item={item} currentUserId={CurrentUserId} />
                    ))
                }

                {
                    Current.isClosed ?
                        <div align="left" className='mt-2'>
                            <rsuite.Button size="sm" onClick={() => SetClosed(Current.id, false)}>
                                باز کردن دوباره
                            </rsuite.Button>
                        </div>
                        :
                        <>
                            <Composer
                                message={Message}
                                onMessageChange={value => setMessage(value)}
                                files={Files}
                                onPick={AddFiles}
                                onRemoveFile={RemoveFile}
                                fileInputRef={FileInputRef}
                                loading={ShowLoader}
                                onSend={SendReply}
                                sendLabel="ارسال پاسخ"
                            />
                            <rsuite.Divider />
                            <div align="left">
                                <rsuite.Button size="sm" appearance="ghost" color="green"
                                    onClick={() => SetClosed(Current.id, true)}>
                                    این گفتگو تمام شد
                                </rsuite.Button>
                            </div>
                        </>
                }
            </div>
        );
    }

    //--> فرم گفتگوی تازه
    if (ShowNew) {
        return (
            <div>
                <rsuite.Button size="sm" appearance="subtle" onClick={() => setShowNew(false)}>
                    ‹ بازگشت به فهرست گفتگوها
                </rsuite.Button>

                <div className='mt-3'>
                    <label>موضوع</label>
                    <rsuite.Input value={Subject} onChange={value => setSubject(value)}
                        placeholder="سوال شما در یک جمله" />
                </div>

                <Composer
                                message={Message}
                                onMessageChange={value => setMessage(value)}
                                files={Files}
                                onPick={AddFiles}
                                onRemoveFile={RemoveFile}
                                fileInputRef={FileInputRef}
                                loading={ShowLoader}
                                onSend={SendNew}
                                sendLabel="ثبت گفتگو"
                            />
            </div>
        );
    }

    //--> فهرست گفتگوهای این وظیفه
    return (
        <div>
            <div style={{ fontSize: 13, color: '#8c97a3', marginBottom: 10 }}>{TaskTitle}</div>

            <div align="left">
                <rsuite.Button appearance="primary" size="sm" onClick={() => setShowNew(true)}>
                    گفتگوی جدید
                </rsuite.Button>
            </div>
            <rsuite.Divider />

            {
                ShowLoader ?
                    <div style={{ padding: 20, textAlign: 'center' }}>
                        <rsuite.Loader content="در حال دریافت اطلاعات..." />
                    </div>
                    :
                    List.length === 0 ?
                        <div style={{ padding: 20, textAlign: 'center', color: '#8c97a3' }}>
                            روی این وظیفه گفتگویی ثبت نشده است
                        </div>
                        :
                        List.map(item => (
                            <div key={item.id} className='HandCursor'
                                style={{ borderTop: '1px solid #e6e9ed', padding: '10px 0' }}
                                onClick={() => OpenConversation(item.id)}>
                                <rsuite.Stack justifyContent="space-between" style={{ flexWrap: 'wrap', gap: 6 }}>
                                    <span style={{ fontSize: 13, fontWeight: 500 }}>{item.subject}</span>
                                    {
                                        item.isClosed ?
                                            <rsuite.Tag>بسته شده</rsuite.Tag>
                                            :
                                            <rsuite.Tag color="green">باز</rsuite.Tag>
                                    }
                                </rsuite.Stack>
                                <div style={{ fontSize: 11, color: '#8c97a3', marginTop: 2 }}>
                                    {item.msgCount} پیام — آخرین: {item.lastMsgSenderName} در {item.lastMsgDate}
                                </div>
                            </div>
                        ))
            }
        </div>
    );
});

export default TaskConversation;
